// extracted by mini-css-extract-plugin
module.exports = {"bgTransparent":"Register_bgTransparent__3x86A","tile":"Register_tile__3H40k","subTitle":"Register_subTitle__3Pyj4"};